module.exports = __webpack_public_path__ + "img/Media-YouTube.a4df5775.svg";